(function () {
    'use strict';

    if (!window.location.pathname.match(/\/news\/.+/g)) return;

    require('lightbox2');
})();
